import rest from 'lib/api/rest';
import actionCreatorsFor from 'lib/api/actionCreatorsFor';
import reducersFor from 'lib/api/reducersFor';
import reducerRegistry from 'lib/reducerRegistry';

import config from 'app/config';

export const statuses = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'Disabled',
        value: 'disabled',
    },
    {
        label: 'Deleted',
        value: 'deleted',
    },
];

const onReceive = (data) => {
    data.deliveryWindows?.forEach((uc) => {
        uc.idX = uc.id;
    });

    if (data.configuration) {
        const raw = data.configuration.packerBoxSizes;
        data.configuration.packerBoxSizes = raw
            ? raw
                  .split(',')
                  .map(Number)
                  .filter((n) => !isNaN(n) && n > 0)
            : [];
    }

    return data;
};

const onSend = (data) => {
    data.deliveryWindows?.forEach((uc) => {
        uc.id = uc.id ?? uc.idX;
    });

    if (data.configuration) {
        const ids = data.configuration.packerBoxSizes;
        data.configuration.packerBoxSizes = Array.isArray(ids)
            ? ids.join(',')
            : (ids ?? '');
    }

    return data;
};

const path = () => {
    return `${config.baseURI}/client`;
};

export default function registerRedux(storePath, types) {
    const reducers = reducersFor(storePath, types);

    reducerRegistry.register(storePath, reducers);

    return {
        actionCreators: actionCreatorsFor(
            storePath,
            types,
            rest(path, onReceive, onSend),
            {
                hasMeta: true,
            }
        ),
        resourceName: 'Client',
        storePath: storePath,
        reducers: reducers,
        registerAdditional: registerRedux,
    };
}
